import {
  FORGET_REQUEST,
  GET_BEARER_TOKEN_REQUEST,
  GET_WORD_PAIR_REQUEST,
  LOGOUT_REQUEST,
  REMEMBER_REQUEST,
  SET_BEARER_TOKEN_REQUEST,
  TOGGLE_SHOW_TRANSLATION,
  TOGGLE_REMEMBERED,
} from '../constants';
import { IGetWordPairRequest } from "../reducers/wordPair";
import { IToggleRemembered } from "../reducers/showRemembered";
import { IForgetRequest, IRememberRequest } from "../sagas/remember";
import { IGetBearerTokenRequest, ILogoutRequest, ISetBearerTokenRequest } from "../reducers/bearerToken";
import { IShowTranslation } from "../reducers/showTranslation";

const getBearerToken = (): IGetBearerTokenRequest => ({
  type: GET_BEARER_TOKEN_REQUEST,
});

const setBearerToken = (bearerToken: string|null): ISetBearerTokenRequest => ({
  type: SET_BEARER_TOKEN_REQUEST,
  bearerToken,
});

const logout = (): ILogoutRequest => ({
  type: LOGOUT_REQUEST,
});

const getWordPair = (): IGetWordPairRequest => ({
  type: GET_WORD_PAIR_REQUEST,
});

const remember = (wordPairId: number): IRememberRequest => ({
  type: REMEMBER_REQUEST,
  wordPairId,
});

const forget = (wordPairId: number): IForgetRequest => ({
  type: FORGET_REQUEST,
  wordPairId,
});

const toggleRemembered = (): IToggleRemembered => ({
  type: TOGGLE_REMEMBERED,
});

const toggleShowTranslation = (): IShowTranslation => ({
  type: TOGGLE_SHOW_TRANSLATION,
});

export {
  getBearerToken,
  setBearerToken,
  logout,
  getWordPair,
  remember,
  forget,
  toggleRemembered,
  toggleShowTranslation,
};
